<template>
  <v-dialog v-model="visible" width="60vw" max-width="90vw" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">名前を付けて保存</span>
      </v-card-title>
      <v-card-text>
        <v-text-field v-if="visible" v-model="name" autofocus />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="onSave" color="primary">保存</v-btn>
        <AppButtonCancel @click="close">閉じる</AppButtonCancel>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { snackbarType } from '@/vuex/modules/ui/snackbar/constants'

export default {
  name: 'SimulationSaveAsNameModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      agencyId: this.$route.params.agencyId,
      name: '',
    }
  },
  computed: {
    ...mapGetters('currentAdvertiser', ['currentAdvertiserId']),
    ...mapGetters('simulation', ['currentStep']),
    isLoginLP() {
      return typeof this.agencyId === 'undefined'
    },
    visible() {
      return this.value
    },
  },
  methods: {
    ...mapActions('snackbar', {
      showSnackbar: 'SHOW_SNACKBAR',
    }),
    async onSave() {
      try {
        this.$emit('toggleIsRegistering')
        // 引き継いではいけない情報をundefinedで上書き
        const basicSetting = this.form.basicSetting
        basicSetting.name = this.name
        basicSetting.advertiserId = undefined
        basicSetting.id = undefined
        basicSetting.hashId = undefined

        const { menuSetting } = this.form.deliverySetting
        menuSetting.id = undefined
        const { simulationCustomLocationGroups } = menuSetting
        const { simulationPoiLocationGroups } = menuSetting
        simulationCustomLocationGroups.simulationLocationGroups.forEach(
          group => {
            group.id = undefined
            group.simulationLocations.forEach(location => {
              location.id = undefined
            })
          },
        )
        simulationPoiLocationGroups.simulationLocationGroups.forEach(group => {
          group.id = undefined
          group.simulationLocations.forEach(location => {
            location.id = undefined
          })
        })
        const { simulationPlan } = await this.form.save()

        this.close()
        this.$emit('toggleIsRegistering')
        this.showSnackbar({
          type: snackbarType.SUCCESS,
          message: 'シミュレーションを保存しました',
        })

        if (this.isLoginLP) {
          this.redirectLoginLPSimulationEdit(simulationPlan.id)
          return false
        }
        this.redirectAdvertiserSimulationEdit(simulationPlan.id)
      } catch (e) {
        this.$emit('toggleIsRegistering')
        this.showSnackbar({
          type: snackbarType.ERROR,
          message: 'シミュレーションの保存に失敗しました',
        })
        this.close()
      }
    },
    close() {
      this.name = ''
      this.$emit('close')
    },
    redirectLoginLPSimulationEdit(simulationId) {
      this.$router.push({
        name: 'LoginLpSimulationEdit',
        params: {
          simulationId,
          initialStep: this.currentStep,
        },
      })
    },
    redirectAdvertiserSimulationEdit(simulationId) {
      this.$router.push({
        name: 'SimulationEdit',
        params: {
          agencyId: this.agencyId,
          advertiserId: this.currentAdvertiserId,
          simulationId,
          initialStep: this.currentStep,
        },
      })
    },
  },
}
</script>

<style scoped></style>
